import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoordinatorFest {
    id: string;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
    logo?: string | null;
}

interface CoordinatorState {
    selectedFest: CoordinatorFest | null;
}

const initialState: CoordinatorState = {
    selectedFest: null,
};

const coordinatorSlice = createSlice({
    name: 'Coordinator',
    initialState,
    reducers: {
        setSelectedCoordinatorFest(state, action: PayloadAction<CoordinatorFest>) {
            state.selectedFest = action.payload;
        },
        clearSelectedCoordinatorFest(state) {
            state.selectedFest = null;
        },
    },
});

export const { setSelectedCoordinatorFest, clearSelectedCoordinatorFest } = coordinatorSlice.actions;
export default coordinatorSlice.reducer;
